import React from 'react';
import Icon from '../shared/Icon';
import { LIBRARY_TYPES, usedBy, plural } from '../../../models/LibraryModel';
import { formatTimestamp } from '../../../shared/datetime/timestamps';
import { showFullTextIfTruncated } from '../../../utils/truncationTooltip';
import LibraryStatusChip from './LibraryStatusChip';
import LibraryDocumentMenu, { ArchivedTip } from './LibraryDocumentMenu';

export function usageLine(doc) {
  const n = usedBy(doc);
  return n ? `Used in ${n} ${plural(n, 'scenario', 'scenarios')}` : 'Not used in a scenario';
}

/**
 * A document as a Dataset Card. The icon names its type on hover; an
 * archived card fades everything it says, the date included, and names its
 * state instead (one tooltip at a time: the state outranks the type, which the
 * open tab already names). The name is where focus lands after an action
 * (`data-doc-focus`).
 */
function LibraryCard({ doc, actions }) {
  const type = LIBRARY_TYPES[doc.type];
  return (
    <div className={`resui-card resui-card--elevated library-card${doc.archived ? ' is-archived' : ''}`}>
      <div className="library-card-icon" data-tip={`${type.label}: ${type.hint.replace(/\.$/, '')}`}>
        <Icon name={type.icon} size={18} />
      </div>
      <div data-doc-focus={doc.id} tabIndex={-1} className="library-card-name" onMouseEnter={showFullTextIfTruncated}>{doc.name}</div>
      <div className="library-card-subs">
        <div className="library-card-sub" onMouseEnter={showFullTextIfTruncated}>{doc.fileName}</div>
        <div className="library-card-sub">{usageLine(doc)}</div>
      </div>
      <div className="library-card-foot">
        <LibraryStatusChip doc={doc} />
        <span className="library-card-date" title={formatTimestamp(doc.uploadedAt, 'long')}>{formatTimestamp(doc.uploadedAt, 'short')}</span>
      </div>
      <LibraryDocumentMenu doc={doc} actions={actions} />
      <ArchivedTip doc={doc} />
    </div>
  );
}

export default LibraryCard;
